const ShimmerBlock = ({
  width = "100%",
  height = 16,
  circle = false,
}: {
  width?: string | number;
  height?: number;
  circle?: boolean;
}): JSX.Element => (
  <div
    className={`DiscussionShimmer${circle ? " DiscussionShimmer_circle" : ""}`}
    style={{ width, height }}
    aria-hidden="true"
  />
);

export const DiscussionsPanelSkeleton = (): JSX.Element => (
  <div className="DiscussionsPanel DiscussionsPanelSkeleton" aria-busy="true" aria-label="Loading discussions">
    <div className="DiscussionsPanel__header">
      <ShimmerBlock width={100} height={20} />
      <ShimmerBlock width={180} height={16} />
    </div>

    <ShimmerBlock height={128} />

    {([0, 1, 2] as const).map((i) => (
      <div key={i} className="DiscussionsPanelSkeleton_thread">
        <ShimmerBlock width={32} height={32} circle />
        <div className="DiscussionsPanelSkeleton_threadBody">
          <ShimmerBlock width={160} height={16} />
          <ShimmerBlock width="90%" height={14} />
          <ShimmerBlock width="70%" height={14} />
        </div>
      </div>
    ))}
  </div>
);
